import React from 'react';

import WelcomeScreen from '../components/Welcome';

const AboutUsPage: React.FC = () => {	
	return (
		<div className="min-h-screen bg-primary">
			<WelcomeScreen />

			<div className='pl-5 pr-5'>
				<h1 className="text-2xl font-bold text-white text-center">About Us</h1>

				<p className="text-white text-center mt-5">
					Meeteasy was co-founded by Nam Tran and Kelsey Coffin in 2024 because they answered yes to all these questions! 
				</p>

				<p className='text-center text-white mt-3 font-bold'>
					Have you ever 
				</p>

				<ul className='text-center mt-10 text-white'>
					<li className='mt-3'>Wondered what to do for the weekend?</li>
					<li className='mt-3'>Solo-ed travel & wanted company?</li>
					<li className='mt-3'>Wanted to hike but none of your friends are available?</li>
					<li className='mt-3'>Wanted to go to a concert/show but can’t find someone to go with?</li>
					<li className='mt-3'>Wanted to make friends without having to join a group?</li>
				</ul>

				<h1 className='text-white text-center mt-10 font-bold text-4xl'>
					If you answered YES to any of these questions, <br/> then meeteasy is also for you!
				</h1>
			</div>
		</div>
	);
};

export default AboutUsPage;